import { Component, ViewChild } from '@angular/core';
import { ActivationStart, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';
import { FcmService } from './services/fcm.service';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import * as moment from 'moment';
import { AlertController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AppRate } from '@ionic-native/app-rate/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx'
import { UpdateService } from './services/update.service';
import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  str: any = String;
  browser_chk: Boolean = true;
  URLlink: any;
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public appRate: AppRate,
    private fcmService: FcmService,
    private platform: Platform,
    public statusBar: StatusBar,
    public alertCtrl: AlertController,
    private _location: Location,
    public device:Device,
    private updateService:UpdateService,
    private ga: GoogleAnalytics,
    private androidPermissions: AndroidPermissions
  ) {
    this.statusBar.hide();
    // this.router.navigate(['tabs/account'])
    this.statusBar.backgroundColorByHexString('#ffffff');
    this.init();
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.browser_chk = true;
    } else {
      this.browser_chk = false;
    }
    this.hardware_btn();
  }
  // init() {
  //   this.platform.ready().then(async () => {
  //     setTimeout(() => {
  //       SplashScreen.hide({
  //         fadeOutDuration: 900,
  //       });
  //     }, 800);
  //     // this.review()
  //     this.analytics()
  //     let check = window.localStorage.getItem('intro_store');
  //     this.str = window.location.hash.toString();
  //     let chk = this.str.includes('image-modal');
  //     this.URLlink = window.location.href;
  //     this.check_platform()

  //     if(this.URLlink == 'https://lsm.com.pk' || this.URLlink == 'http//lsm.com.pk' || this.URLlink == 'http://localhost:8100/'){
  //       if (check == 'true') {
  //           } else {
  //             if (chk == true) {
  //             } else {
  //               this.router.navigate(['get-started']);
  //             }
  //           }
  //     }
  //     if(this.URLlink.includes('product-detail')) {
  //     }if(this.URLlink.includes('supply-detail')) {
  //     }if(this.URLlink.includes('privacy-policy')) {
  //     }if(this.URLlink.includes('terms')) {
  //     } else {
  //       if (check == 'true') {
  //       } else {
  //         if (chk == true) {
  //         } else {
  //           this.router.navigate(['get-started']);
  //         }
  //       }
  //     }
  //     this.updateService.checkForUpdate()
  //   if (this.platform.is('ios') || this.platform.is('android')) {
  //      this.fcmService.initPush();
  //   }
  //   });

  // }


  init() {
    this.platform.ready().then(async () => {
      setTimeout(() => {
        SplashScreen.hide({
          fadeOutDuration: 900,
        });
      }, 800);
      this.review()
      // this.analytics()
      let check = window.localStorage.getItem('intro_store');
      this.str = window.location.hash.toString();
      let chk = this.str.includes('image-modal');
      this.URLlink = window.location.href;
      this.check_platform()
      if(this.URLlink == 'https://lsm.com.pk' || this.URLlink == 'http//lsm.com.pk' || this.URLlink == 'http://localhost:8100/'){
        if (check == 'true') {
            } else {
              if (chk == true) {
              } else {
                this.router.navigate(['get-started']);
              }
            }
      }
      if(this.URLlink.includes('product-detail')) {
      }else if(this.URLlink.includes('supply-detail')) {
      }else if(this.URLlink.includes('privacy-policy')) {
      }else if(this.URLlink.includes('help')){}
      else if(this.URLlink.includes('terms')) {
      } else {
        if (check == 'true') {
        } else {
          if (chk == true) {
          } else {
            this.router.navigate(['get-started']);
          }
        }
      }
      this.updateService.checkForUpdate()
    if (this.platform.is('ios') || this.platform.is('android')) {
       this.fcmService.initPush();
    }
    });
  }


  check_platform() {
    if (this.platform.is('ios')) {
      window.localStorage.setItem('platform', 'ios')
      const iphoneModel = this.device.model;
      let m = iphoneModel.match(/iPhone(\d+),?(\d+)?/);
      if (m == null) {
        m = iphoneModel.match(/iPad(\d+),?(\d+)?/);
      }
      const model = +m[1];
      if (model > 10) {
        window.localStorage.setItem('phone-model', '10')
        window.localStorage.setItem('platform', 'ios')
      } else {
        window.localStorage.setItem('phone-model', '9')
        window.localStorage.setItem('platform', 'ios')
      }
    } else if (this.platform.is('android')) {
      window.localStorage.setItem('platform', 'android')
    }else {
      window.localStorage.setItem('platform', 'web')
    }
  }

  hardware_btn() {
    this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {
           if (this._location.isCurrentPathEqualTo('/tabs/home')) {
        // Show Exit Alert!
        this.showExitConfirm();
        processNextHandler();
      } else {
        // Navigate to back page
        this._location.back();
      }
    });

    this.platform.backButton.subscribeWithPriority(5, () => {
      this.alertCtrl
        .getTop()
        .then((r) => {
          if (r) {
            navigator['app'].exitApp();
          }
        })
        .catch((e) => {
        });
    });
  }
  showExitConfirm() {
    this.alertCtrl
      .create({
        cssClass: 'my-alert',
        header: 'App termination',
        message: 'Do you want to close the app?',
        mode: 'ios',
        backdropDismiss: false,
        buttons: [
          {
            text: 'Stay',
            role: 'cancel',
            handler: () => {
            },
          },
          {
            text: 'Exit',
            handler: () => {
              navigator['app'].exitApp();
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }
  ask_review() {

  }
  task() {
    this.alertCtrl
      .create({
        cssClass: 'my-alert',
        header: 'Like using LSM App?',
        message: 'Recommend us to others by rating us on Playstore',
        mode: 'ios',
        backdropDismiss: false,
        buttons: [
          {
            text: 'Rate it!',
            // role: 'Ok',
            handler: () => {
              // this.review()
            },
          },
          {
            text: 'Ask Later',
            handler: () => {
              let date = moment().add(5, 'days').calendar();
              window.localStorage.setItem('ask_later', date);
              // navigator['app'].exitApp();
            },
          },
          {
            text: 'Cancel',
            handler: () => {
              window.localStorage.setItem('review_lsm', 'done');

              // navigator['app'].exitApp();
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }

  review() {

    this.platform.ready().then(async () => {
      this.appRate.setPreferences({
        storeAppURL: {
          // ios: '&lt;app_id>',
          android: 'market://details?id=&lt;com.lsm.app',
          // windows: 'ms-windows-store://review/?ProductId=&lt;store_id>'
        },
      });


      this.appRate.promptForRating(true);
    });
  }

analytics(){
  this.ga.startTrackerWithId('UA-EQ16LHLV3X-Y')
   .then(() => {
      this.ga.trackEvent('Category', 'Action')
   }).catch(e => console.log('Error starting GoogleAnalytics', e));
}
    //  fist commit
  trackEvent(category,action){
    this.ga.trackEvent(category, action)
  }
}


